// components/Scroller.jsx
import React, { forwardRef, useImperativeHandle } from "react";
import ScrollToBottom, { useScrollToBottom } from "react-scroll-to-bottom";

const Bridge = forwardRef(function Bridge({ children }, ref) {
  const _scrollToBottom = useScrollToBottom();

  useImperativeHandle(ref, () => ({
    scrollToBottom(options = { behavior: "smooth" }) {
      _scrollToBottom(options);
    },
  }));

  return <>{children}</>;
});

const Scroller = forwardRef(function Scroller({ className, children }, ref) {
  return (
    <ScrollToBottom className={className} scrollViewClassName="chat-scroll">
      <Bridge ref={ref}>{children}</Bridge>
    </ScrollToBottom>
  );
});

export default Scroller;
